import { axiosInstance } from "../axios";

// 获取基本信息与订单时间线
export function fetchTimeLine(params) {
  // return axiosInstance.get("/ark/arkservice/orderinfo/timeLine", { params });
  return axiosInstance.get("/ark/arkservice/orderinfo/timeLine", { params });
}

// 查询拼友信息
export function fetchGetTravelInfo(params) {
  return axiosInstance.get("/ark/orderinfo/getTravelInfo", { params });
}

// 补偿工具 - 补偿原因
/* 
organization_id=1&customerType=1
*/
export function fetchGetCompensateReasonList(params) {
  return axiosInstance.get("/ark/compensate/getCompensateReasonList", {
    params,
  });
}

// 关单
export function fetchCloseOrder(params) {
  return axiosInstance.get("/ark/orderinfo/closeOrder", { params });
}

// 工单关联订单
export function fetchGetOpenTicketByOrder(params) {
  return axiosInstance.get("/ark/ticket/getOpenTicketByOrder", { params });
}

// IM信息
export function fetchGetImHistory(params) {
  return axiosInstance.get("/ark/hisMsgs/getImHistory", { params });
}

// 通话记录
export function fetchGetCallHistory(params) {
  return axiosInstance.get("/ark/hisMsgs/getCallHistory", { params });
}

// 订单信息
export function fetchGetBusStationInfo(params) {
  return axiosInstance.get(
    "/ark/arkservice/orderinfo/getBusStationInfo",
    { params }
  );
}

// 订单查询信息
export function getProvider(params) {
  return axiosInstance.get(
    "/ark/arkservice/common/getProvider",
    { params }
  );
}

// 订单列表
export function getOrderListByCondition(params) {
  return axiosInstance.post(`/ark/arkservice/common/getOrderListByCondition`, params)
}

// cs动态权限:http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=805008312

// 预绑定工单ID与进线号码
export function preBinding(params) {
    return axiosInstance.post('/ark/arkservice/dynamic/preBinding', params)
}

// 验真详情(决定是否展示验真按钮)
export function verificationDetail(params) {
    return axiosInstance.get('/ark/dynamic/verificationDetail', {params})
}

// 查询是否展示隐私信息(是否有动态权限)
export function fetchQueryPrivacyRights(params) {
    return axiosInstance.get('/ark/dynamic/queryPrivacyRights', {params})
}

// 查询是否展示ToolBox(是否有动态权限)
export function fetchShowToolBox(params) {
    return axiosInstance.get('/ark/dynamic/showToolBox', {params})
}

// 绑定场景查询
export function bindingSceneQuery(params) {
    return axiosInstance.post('/ark/arkservice/dynamic/bindingSceneQuery', params)
}